<template>
    <div>
        <div class="hide_scroll" v-if="imgSrcArr && imgSrcArr.length > 0" style="border-bottom:1px solid #EBEBEB; overflow-x: auto; white-space: nowrap;" ref="imgSrcArrWrap">
            <div v-for="each, i in imgSrcArr" :key="'img' + i" style="width:100px; height:100px; position: relative;overflow:hidden;display: inline-block; vertical-align: top; transition: all 0.3s; border-radius:13px;" :style="{ width: each.isEnlarge ? each.large_width + 'px' : each.default_width + 'px', height: each.isEnlarge ? each.large_height + 'px' : each.default_height + 'px', marginLeft: i > 0 ? '10px' : null }" @click.stop="toggleEnlargeImg($event, i)">
                <img v-if="each.thumPath" :ref="'img' + i" :src="$resourcePath + each.thumPath" class="upload_img">
                <img v-else :ref="'img' + i" :src="each.src" class="upload_img">
                <div v-if="!isHiddenDeleteBtn" style="position:absolute; right:0px; top:0px; padding:5px;" :style="{top : isDeleteBottom ? null : '0px', bottom : isDeleteBottom ? '0px' : null }" @click.stop="deleteImageOne(i)">
                    <img :src="require('@/assets/img/rounded_trash_can.png')" style="width:30px; height:30px;">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "SoccerHowWriteFormImageSlider",
    props: {
        imgSrcArr: {
            type: Array,
            default: () => []
        },
        detectDeleteImageOne: {
            type: Function,
            default: () => { }
        },
        isHiddenDeleteBtn: {
            type: Boolean,
            default: false
        },
        isDeleteBottom : {
            type : Boolean,
            default : false
        }
    },
    data() {
        return {
            image_gap: 20,
        }
    },
    methods: {
        __refreshWhenImageAdded() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    for (let i = 0; i < this.imgSrcArr.length; i++) {
                        const cur_target = this.$refs['img' + i][0];
                        const ratio = parseFloat(cur_target.naturalHeight) / parseFloat(cur_target.naturalWidth);

                        let width = 0;
                        let default_width = 0;
                        const imgSrcArrWrapWidth = this.$refs.imgSrcArrWrap.offsetWidth;
                        if (this.imgSrcArr.length === 1) {
                            width = imgSrcArrWrapWidth;
                            default_width = imgSrcArrWrapWidth;
                        } else {
                            width = imgSrcArrWrapWidth;
                            default_width = (imgSrcArrWrapWidth - (this.image_gap / 2)) / 2;
                        }

                        this.imgSrcArr[i].default_width = default_width;
                        this.imgSrcArr[i].default_height = imgSrcArrWrapWidth / 2;

                        this.imgSrcArr[i].large_width = width;
                        this.imgSrcArr[i].large_height = parseInt(ratio * width);
                    }
                });

            })
        },
        deleteImageOne(index) {
            this.detectDeleteImageOne(index);
            this.$delete(this.imgSrcArr, index);
            this.__refreshWhenImageAdded();
        },
        toggleEnlargeImg(e, index) {
            this.$set(this.imgSrcArr[index], 'isEnlarge', !this.imgSrcArr[index].isEnlarge);
            if (index > 0) {
                let curAnimationFrame;
                let width = this.$refs.imgSrcArrWrap.offsetWidth;
                let start_time = new Date().getTime();

                const recursiveAnimate = () => {
                    (this.$refs.imgSrcArrWrap.scrollBy(width + this.image_gap, 0))
                    if (new Date().getTime() - start_time > 400) {
                        cancelAnimationFrame(curAnimationFrame);
                        return;
                    }
                    curAnimationFrame = requestAnimationFrame(recursiveAnimate);
                }

                this.$nextTick(() => {
                    recursiveAnimate();
                })
            }
        },
    }
}
</script>

<style scoped>
.upload_img {
    min-width: 100%;
    object-fit: cover;
    max-height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.upload_img+.upload_img {}
</style>